const STORAGE_KEYS = {
  id: "surveyId",
  data: "surveyData",
};

export { STORAGE_KEYS };
